<template>
    <div>
        <!-- #region بيانات المنشأة -->
        <v-card elevation="3" class="my-8 mb-6" style="padding:20px;">
            <div class="row">
                <h4 class="mb-5 w-100 py-3" style="padding-right:20px;">
                    <b v-if="partner.facilityName"> {{partner.facilityName}}</b>
                    <b v-else> بيانات المنشأة</b>
                </h4>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow">
                    <label for="disabledTextInput">الصفة</label>
                    <p class="mb-0">
                        <b>منشأة</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.nationalUnifiedNumber">
                    <label for="disabledTextInput">الرقم الوطني الموحد</label>
                    <p class="mb-0">
                        <b>{{partner.nationalUnifiedNumber}}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.commercialRegister">
                    <label for="disabledTextInput"> رقم السجل التجاري</label>
                    <p class="mb-0">
                        <b>{{partner.commercialRegister}}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.commercialRegisterStatusName">
                    <label for="disabledTextInput"> حالة السجل التجاري</label>
                    <p class="mb-0">
                        <b>{{partner.commercialRegisterStatusName}}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow">
                    <label>الرقم الضريبي   </label>
                    <p class="mb-0" v-if="partner.taxNumber">  <b>{{partner.taxNumber}}</b></p>
                    <p class="mb-0" v-else>لايوجد</p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.organizationTypeName">
                    <label for="disabledTextInput">نوع المنشأة</label>
                    <p class="mb-0">
                        <b>{{partner.organizationTypeName}}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow">
                    <label>رقم المنشأة   </label>
                    <p class="mb-0" v-if="partner.facilityNumber">  <b>{{partner.facilityNumber}}</b></p>
                    <p class="mb-0" v-else>-</p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow">
                    <label>نوع الرخصة  </label>
                    <p class="mb-0"><b v-if="partner.licenseTypeName"> {{ partner.licenseTypeName }} </b><b v-else> - </b></p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow">
                    <label>رقم الرخصة  </label>
                    <p class="mb-0"><b v-if="partner.licenseNumber"> {{ partner.licenseNumber }} </b><b v-else> - </b></p>
                </div>

                <div class="col-lg-3 col-md-2 col-sm-12 cutom-box-shadow">
                    <label>تاريخ بداية الرخصة  </label>
                    <p class="mb-0">
                        <b v-if="partner.licenseStartDate">
                            {{ partner.licenseStartDate | formatGregToHijri }} هـ -
                            {{ partner.licenseStartDate | getFormattedDate }}م
                        </b>
                        <b v-else> - </b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow">
                    <label>تاريخ نهاية الرخصة  </label>
                    <p class="mb-0">
                        <b v-if="partner.licenseEndDate">
                            {{ partner.licenseEndDate | formatGregToHijri }} هـ -
                            {{ partner.licenseEndDate | getFormattedDate }}م
                        </b>
                        <b v-else> - </b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.iban">
                    <label for="disabledTextInput">الآيبان للمنشأة</label>
                    <p class="mb-0">
                        <b>{{partner.iban}}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.mobileNumber">
                    <label for="disabledTextInput">رقم التواصل</label>
                    <p class="mb-0"> <b>{{ partner.mobileNumber }}</b></p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.email">
                    <label for="disabledTextInput">البريد الإلكتروني</label>
                    <p class="mb-0"> <b>{{ partner.email }}</b></p>
                </div>

                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow">
                    <label for="disabledTextInput">رقم الهاتف </label>
                    <p class="mb-0">

                    <p class="mb-0" v-if="partner.telephone"> <b>{{partner.telephone}}</b></p>
                    <p class="mb-0" v-else>  لايوجد </p>
                </div>

                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="partner.abbreviatedNationalAddress">
                    <label for="disabledTextInput">العنوان الوطني المختصر  </label>
                    <p class="mb-0">
                    </p>
                    <p class="mb-0" v-if="partner.abbreviatedNationalAddress">  <b>{{partner.abbreviatedNationalAddress}}</b></p>
                    <p class="mb-0" v-else>لايوجد</p>

                </div>

                <div class="row"></div>

                <div class="col-lg-12 col-md-12 col-sm-12 cutom-box-shadow" v-if="partner.nationalAddress">
                    <label for="disabledTextInput">العنوان الوطني</label>
                    <p class="mb-0">
                        <!--<b>المدينة: {{ partner.nationalAddress.city }} - الحي: {{ partner.nationalAddress.district }} - الشارع : {{ partner.nationalAddress.street }} - رقم المبني: {{ partner.nationalAddress.buildingNumber }} - الرقم الفرعي: {{ partner.nationalAddress.subNumber }} - الرقم البريدي : {{ partner.nationalAddress.postalCode }}</b>-->
                        <b>المدينة: <b v-if="partner.nationalAddress.city"> {{ partner.nationalAddress.city }} </b> <b v-else> - </b> ، </b>
                        <b>الحي: <b v-if="partner.nationalAddress.district"> {{ partner.nationalAddress.district }} </b> <b v-else> - </b> ، </b>
                        <b>الشارع: <b v-if="partner.nationalAddress.street"> {{ partner.nationalAddress.street }} </b> <b v-else> - </b> ، </b>
                        <b>رقم المبني: <b v-if="partner.nationalAddress.buildingNumber"> {{ partner.nationalAddress.buildingNumber }} </b> <b v-else> - </b> ، </b>
                        <b>الرقم الفرعي: <b v-if="partner.nationalAddress.subNumber"> {{ partner.nationalAddress.subNumber }} </b> <b v-else> - </b> ، </b>
                        <b>الرمز البريدي: <b v-if="partner.nationalAddress.postalCode"> {{ partner.nationalAddress.postalCode }} </b> <b v-else> - </b></b>
                    </p>
                </div>

            </div>
            <br />
        </v-card>
        <!-- #endregion -->

    </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import { ContractDetails } from '@/models/contract.model';
    import { ContractPartnerModel } from '@/models/contractPartnerModel';

    @Component
    export default class ContractEntityComponent extends Vue {
        @Prop({ required: true }) partner!: ContractPartnerModel;
    }
</script>